module.exports = __webpack_public_path__ + "img/radio-terengganu.eabe5ef2.jpg";